import { render, staticRenderFns } from "./ServicioSocialDescargasPage.vue?vue&type=template&id=08efddfa&scoped=true&"
import script from "./ServicioSocialDescargasPage.vue?vue&type=script&lang=js&"
export * from "./ServicioSocialDescargasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efddfa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ServicioSocialDescargasPage.vue
// module id = 216
// module chunks = 16